import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './button.magic.css.js';
import script from './button.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.buttonTag,_vm._b({tag:"component",staticClass:"button",class:[_vm.buttonVariant, {
        'button--hollow': _vm.hollow,
        'button--icon': _vm.icon,
        'button--round': _vm.round,
        'button--left': _vm.left,
        'button--right': _vm.right,
        'button--large': _vm.large,
        'button--small': _vm.small,
        'button--small-extra-padding': _vm.smallExtraPadding,
        'button--tiny': _vm.tiny,
        'button--wide': _vm.wide,
        'button--no-margin': _vm.noMargin,
        'button--less-margin': _vm.lessMargin,
        'button--no-padding': _vm.noPadding,
        'button--less-padding': _vm.lessPadding,
        'button--add-space': _vm.addSpace,
        'is-loading': _vm.loading,
        'is-disabled': _vm.$attrs.disabled,
    }],attrs:{"to":_vm.to,"data-v-test-id":_vm.$attrs['test-id'],"part":_vm.$p('button', [_vm.buttonVariant, {
        'button--hollow': _vm.hollow,
        'button--icon': _vm.icon,
        'button--round': _vm.round,
        'button--left': _vm.left,
        'button--right': _vm.right,
        'button--large': _vm.large,
        'button--small': _vm.small,
        'button--small-extra-padding': _vm.smallExtraPadding,
        'button--tiny': _vm.tiny,
        'button--wide': _vm.wide,
        'button--no-margin': _vm.noMargin,
        'button--less-margin': _vm.lessMargin,
        'button--no-padding': _vm.noPadding,
        'button--less-padding': _vm.lessPadding,
        'button--add-space': _vm.addSpace,
        'is-loading': _vm.loading,
        'is-disabled': _vm.$attrs.disabled,
    }])}},'component',_vm.$filteredAttrs,false),[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6561b025_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-6561b025";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
